import React from 'react'
import { Content } from './styles'

const Container: React.FC = ({ children }) => {
  return <Content>{children}</Content>
}

export default Container
